/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteEvalScheduleRequest = {
  scheduleId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteEvalScheduleRequest$inboundSchema: z.ZodType<
  DeleteEvalScheduleRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  schedule_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "schedule_id": "scheduleId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteEvalScheduleRequest$Outbound = {
  schedule_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteEvalScheduleRequest$outboundSchema: z.ZodType<
  DeleteEvalScheduleRequest$Outbound,
  z.ZodTypeDef,
  DeleteEvalScheduleRequest
> = z.object({
  scheduleId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    scheduleId: "schedule_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteEvalScheduleRequestToJSON(
  deleteEvalScheduleRequest: DeleteEvalScheduleRequest,
): string {
  return JSON.stringify(
    DeleteEvalScheduleRequest$outboundSchema.parse(deleteEvalScheduleRequest),
  );
}
export function deleteEvalScheduleRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteEvalScheduleRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteEvalScheduleRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteEvalScheduleRequest' from JSON`,
  );
}
